import { TechLibraryDocumentFilterModel } from '@customer/store/apis/assetsApi';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { setTechLibFilters } from '@customer/store/slices/filtersSlice';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useShowLibrary = (filter: TechLibraryDocumentFilterModel | null | undefined) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const siteId = useAppSelector(state => state.auth.siteId);

  return useCallback(() => {
    if (filter && siteId) {
      dispatch(
        setTechLibFilters({
          docTypes: filter.documentType,
          families: filter.fams,
          products: filter.prods,
          siteId: siteId,
        }),
      );

      navigate('/techlibrary');
    }
  }, [dispatch, navigate, siteId, filter]);
};
